import { render } from "./OrderButtons.vue?vue&type=template&id=09e5bcf2&scoped=true"
import script from "./OrderButtons.vue?vue&type=script&lang=js"
export * from "./OrderButtons.vue?vue&type=script&lang=js"

import "./OrderButtons.vue?vue&type=style&index=0&id=09e5bcf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e5bcf2"]])

export default __exports__